<template>
  <div
    :class="tagColor"
    class="smart__tag inline-flex align-center justify-center px-1 font-medium">
    <span class="inline-block smart__tag--circle ml-1-2 mr-1" />
    {{ label }}
  </div>
</template>

<script>
// @flow
export default {
  name: 'SmartTag',
  props: {
    color: {
      type: String,
      default: 'danger'
    },
    label: {
      type: String,
      default: 'Nova visita criada',
      required: true
    }
  },
  computed: {
    tagColor() {
      return `smart__tag--color-${this.color}`;
    }
  },
  methods: {
    tagColorByStatus() {
      if (this.label === 'PENDENTE') {
        this.color = 'danger';
      } else if (this.label === 'AGENDADO') {
        this.color = 'success';
      } else if (this.label === 'CANCELADA') {
        this.color = 'danger';
      } else if (this.label === 'OK') {
        this.color = 'success';
      } else if (this.label === 'ATRASADO') {
        this.color = 'danger';
      } else {
        this.color = 'accent';
      }
    }
  },
  mounted() {
    this.tagColorByStatus();
  }
};
</script>

<style scoped lang="scss">
$tagColors: (
  accent: $color-ui-accent,
  blue: $color-brand-primary,
  danger: $color-ui-danger,
  success: $color-ui-success
);
.smart__tag {
  border-radius: $border-radius-circle;
  background: rgba($color-ui-gray, $opacity-low-min);
  color: $color-ui-gray;
  font-size: 12px;
  height: 24px;
  &--circle {
    height: 4px;
    width: 4px;
    background: currentColor;
    border-radius: $border-radius-circle;
  }
  @each $tag, $color in $tagColors {
    &--color-#{$tag} {
      color: $color;
      background: rgba($color, $opacity-low-min);
    }
  }
}
</style>
